import { useState, useCallback, useContext } from 'react';
import { useAuth } from '../context/AuthContext';


export const useApi = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { accessToken, logout, setAccessTokenValue } = useAuth();

    const callApi = useCallback(async ({ url, method = 'GET', headers, body }) => {
        setLoading(true);
        setError(null);

        const makeRequest = async (token) => {
            const response = await fetch(url, {
                method,
                headers: {
                    'Authorization': `Bearer ${token || accessToken}`,
                    ...(headers || {}),
                },
                body: body ? body : undefined,
            });
            return response;
        };

        try {
            // FIRST REQUEST
            let response = await makeRequest();

            // IF TOKEN EXPIRED → TRY REFRESH
            if (response.status === 403) {
                console.log("403 detected → trying refresh token");

                const requestToken = await fetch(`${process.env.REACT_APP_BACKEND_ENDPOINT}/auth/refreshWeb`, {
                    method: "POST",
                    credentials: "include"
                })

                const newToken = await requestToken.json();
                console.log(newToken);

                if (newToken.status!==200) {
                    console.log("Refresh failed → logging out");
                    logout();
                    throw new Error("Session expired. Please log in again.");
                }

                // RETRY ORIGINAL REQUEST WITH NEW TOKEN
                setAccessTokenValue(newToken?.data?.accessToken)
                response = await makeRequest(newToken?.data?.accessToken);
            }

            // STILL NOT OK AFTER RETRY
            if (!response.ok) {
                let errMsg = "Something went wrong while making API call";

                try {
                    const jsonError = await response.json();
                    errMsg = jsonError?.message || errMsg;
                } catch { }

                setError(errMsg);
                throw new Error(errMsg);
            }

            // SUCCESS
            const data = await response.json();
            return data;

        } catch (err) {
            setError(err?.message || err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [accessToken, logout]); // refresh token

    return { callApi, loading, error };
};

export default useApi;